import { ApiSchema } from '../lib/query/apiClient';
import { Language } from '../models';
import { apiDispatcher } from '../utils';

type SessionConfiguration = ApiSchema<'SessionConfiguration'>;

const baseUrl = '/api/v1/session';

export const getCurrentConfiguration = (): Promise<SessionConfiguration> => {
  return apiDispatcher<SessionConfiguration>(`${baseUrl}/current/configuration`, 'GET');
};

export const setLanguage = (lang: Language) => {
  return apiDispatcher(`${baseUrl}/current/language`, 'POST', lang, { resolver: () => Promise.resolve(lang) });
};
